/**
 * CORE-1356 — почему вложение не взяли, словами для человека.
 *
 * Возврат QA 25.09: загрузка не удавалась, а человек видел только значок на
 * чипе. Кнопка отправки при этом выключена, пока вложение «загружается», и
 * снаружи это выглядит как мёртвый интерфейс: текст в поле, ничего не
 * происходит, объяснения нет.
 *
 * Отдельным модулем, а не внутри треда: это чистая функция, её проверяют
 * тестом, а тред тянет за собой пол-приложения.
 *
 * `validateFile` отвечает по-английски и адресован разработчику
 * («Unsupported file type: …»). Показывать это в чате нельзя — английских
 * строк для человека в продукте нет.
 */

/**
 * Что делать дальше. Сообщение без выхода хуже молчания.
 *
 * CORE-1791 (возврат QA 23.10) — на «вы» и без «я». Строка стоит там же, где
 * отказ отправки (CORE-1350: «Текст сохранён, попробуйте ещё раз») и отказы
 * вложений чатов сообщества («Файл … такого формата не принимается»), и
 * говорит интерфейс, а не Агапелла: в личном диалоге «я пока не принимаю»
 * было бы непонятно от кого.
 */
const RETRY = 'Уберите его крестиком и попробуйте ещё раз — текст останется здесь.';

export function refusalText(rawError: string, fileName: string): string {
  if (/too large/i.test(rawError)) {
    return `Файл «${fileName}» слишком большой. ${RETRY}`;
  }
  if (/unsupported file type/i.test(rawError)) {
    return `Файл «${fileName}» такого формата не принимается. ${RETRY}`;
  }
  return `Не удалось загрузить «${fileName}». ${RETRY}`;
}
